angular.module('bmsApp.settings')
	.controller('OnlineSlotsCtrl', OnlineSlotsCtrl);

OnlineSlotsCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$filter',
	'notify',
	'LicenseOptionsSvc',
	'OnlineSlotsSvc',
];

function OnlineSlotsCtrl($scope, $state, $q, $filter, notify, LicenseOptionsSvc, OnlineSlotsSvc) {
	let self = this;
	let handlers = {};

	let defaultDatePickerConfig = {
		storageFormat: 'YYYY-MM-DD',
		'options': {
			format: 'Do MMMM YYYY',
			singleDatePicker: true,
			showDropdowns: true,
			showWeekNumbers: true,
			opens: 'right',
			drops: 'down',
			parentEl: '#work-container .content-scroll'
		},
		'eventHandlers': {}
	};

	self.timePickerConfig = {
		step: 30,
		timeFormat: 'G:ia',
		asMoment: true,
		minTime: '08:00',
		appendTo: '.content-scroll'
	};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
		options: {},
	});

	this.$onInit = () => {
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});
	};

	function generateWeeks() {
		let weeksInAdvance = 9;
		let today = moment.utc().subtract(1, 'week')
			.startOf('week');

		let weeksArray = [];
		let displayWeeksArray = [];

		for (let i = 0; i < weeksInAdvance; i++) {

			let existingWeek = $filter('filter')(self.existingWeeks, (item) => {
				let weekCommencingAt = moment.utc(item.week_commencing_at);
				return weekCommencingAt.isSame(today, 'day');
			});

			if (existingWeek.length) {
				weeksArray.push(existingWeek[0]);
				angular.forEach(existingWeek[0].slots, (slot) => {
					slot.start_time = moment.utc(slot.slot_date + ' ' + slot.start_time, "YYYY-MM-DD HH:mm:ss");
					slot.end_time = moment.utc(slot.slot_date + ' ' + slot.end_time, "YYYY-MM-DD HH:mm:ss");
				});
			}
			else {
				weeksArray.push({
					license_id: self.license.id,
					week_no: today.format('W'),
					week_commencing_at: today.format(),
					slots: [],
				});
			}

			displayWeeksArray.push({
				license_id: self.license.id,
				week_no: today.format('W'),
				week_commencing_at: today.format(),

				days: [
					{
						day: 'Mon',
						date: today.clone()
							.format(),
						disabled: today.clone().add(1, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().format('YYYY-MM-DD');
						}) : [],
					},
					{
						day: 'Tue',
						date: today.clone()
							.add(1, 'day')
							.format(),
						disabled: today.clone().add(2, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().add(1, 'day').format('YYYY-MM-DD');
						}) : [],
					},
					{
						day: 'Wed',
						date: today.clone()
							.add(2, 'day')
							.format(),
						disabled: today.clone().add(3, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().add(2, 'day').format('YYYY-MM-DD');
						}) : [],
					},
					{
						day: 'Thu',
						date: today.clone()
							.add(3, 'day')
							.format(),
						disabled: today.clone().add(4, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().add(3, 'day').format('YYYY-MM-DD');
						}) : [],
					},
					{
						day: 'Fri',
						date: today.clone()
							.add(4, 'day')
							.format(),
						disabled: today.clone().add(5, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().add(4, 'day').format('YYYY-MM-DD');
						}) : [],
					},
					{
						day: 'Sat',
						date: today.clone()
							.add(5, 'day')
							.format(),
						disabled: today.clone().add(6, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().add(5, 'day').format('YYYY-MM-DD');
						}) : [],
					},
					{
						day: 'Sun',
						date: today.clone()
							.add(6, 'day')
							.format(),
						disabled: today.clone().add(6, 'day').isBefore(moment.utc()),
						slots: existingWeek.length ? $filter('filter')(existingWeek[0].slots, (slot) => {
							return  slot.slot_date == today.clone().add(6, 'day').format('YYYY-MM-DD');
						}) : [],
					},
				],
			});
			today.add(1, 'week');
		}

		self.weeks = weeksArray;
		self.displayWeeks = displayWeeksArray;
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.licenseChanged = () => {
		OnlineSlotsSvc.index({filter: {license: self.license.id}})
			.then((response) => {
				self.existingWeeks = response.data.collection;
				generateWeeks();
			});
	};

	// Why i didn't do this - PITA to update all the dates after copying
	// handlers.copyFromPreviousWeek = (week) => {
	// 	// Find previous week
	// 	let previousWeek = $filter('filter')(self.displayWeeks, (_week) => {
	// 		return parseInt(week.week_no) - 1 === parseInt(_week.week_no);
	// 	});
	// 	if (previousWeek.length) {
	// 		angular.extend(week, {
	// 			days: previousWeek[0].days,
	// 		});
	//
	// 		let _copyFromWeek = $filter('filter')(self.weeks, (_week) => {
	// 			return parseInt(week.week_no) - 1 === parseInt(_week.week_no);
	// 		});
	//
	// 		let _copyToWeek = $filter('filter')(self.weeks, (_week) => {
	// 			return parseInt(week.week_no) === parseInt(_week.week_no);
	// 		});
	//
	// 		angular.extend(_copyToWeek[0], {
	// 			slots: _copyFromWeek[0].slots,
	// 		});
	//
	// 		console.log(self.weeks);
	// 	}
	// };

	handlers.addSlot = (week, day) => {
		let newSlot = {};
		day.slots.push(newSlot);

		let weekCommencingAt = moment.utc(week.week_commencing_at);
		angular.forEach(self.weeks, (_week) => {
			let date = moment.utc(_week.week_commencing_at);
			if (date.isSame(weekCommencingAt)) {
				angular.extend(newSlot, {
					slot_date: day.date,
				});
				_week.slots.push(newSlot);
			}
		});
	};

	handlers.removeSlotClick = (slot, day) => {
		if (day.slots.indexOf(slot) >= 0) {
			day.slots.splice(day.slots.indexOf(slot), 1);
		}
		angular.forEach(self.weeks, (week) => {
			if (week.slots.indexOf(slot) >= 0) {
				week.slots.splice(week.slots.indexOf(slot), 1);
			}
		});
	};

	function validateOverlaps() {
		let overlaps = false;

		angular.forEach(self.displayWeeks, (week) => {
			week.overlaps = false;
			angular.forEach(week.days, (day) => {
				let slots = day.slots;
				angular.forEach(slots, (compareFromSlot) => {
					compareFromSlot.overlaps = false;
					let slotStart = moment.utc(compareFromSlot.start_time);
					let slotEnd = moment.utc(compareFromSlot.end_time);
					angular.forEach(slots, (compareToSlot) => {
						if (compareFromSlot === compareToSlot) {
							return;
						}
						let currentSlotStart = moment.utc(compareToSlot.start_time);
						let currentSlotEnd = moment.utc(compareToSlot.end_time);

						if (slotStart.isBefore(currentSlotEnd) && slotEnd.isAfter(currentSlotStart)) {
							angular.extend(compareFromSlot, {
								overlaps: true,
							});
							week.overlaps = true;
							overlaps = true;
						}
					});
				});
			});
		});

		return overlaps;
	}

	function validateDates() {
		let dateErrors = false;

		angular.forEach(self.displayWeeks, (week) => {
			week.dateErrors = false;
			angular.forEach(week.days, (day) => {
				let slots = day.slots;
				angular.forEach(slots, (slot) => {
					slot.dateErrors = false;
					let slotStart = moment.utc(slot.start_time);
					let slotEnd = moment.utc(slot.end_time);
					if (slotStart.isAfter(slotEnd)) {
						slot.dateErrors = true;
						week.dateErrors = true;
						dateErrors = true;
					}
				});
			});
		});

		return dateErrors;
	}

	handlers.submitClick = function () {
		let dateErrors = validateDates();
		if (!dateErrors) {
			let overlaps = validateOverlaps();
			if (!overlaps) {
				OnlineSlotsSvc.save(self.weeks)
					.then((response) => {
						handlers.licenseChanged();
						notify({
							message: 'Time slots updated',
						});
					});
			}
		}
	};
}